'use strict'; // Generated from solidity-antlr4/Solidity.g4 by ANTLR 4.7.2
// jshint ignore: start

var antlr4 = require('../antlr4/index'); // This class defines a complete listener for a parse tree produced by SolidityParser.


function SolidityListener() {
  antlr4.tree.ParseTreeListener.call(this);
  return this;
}

SolidityListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
SolidityListener.prototype.constructor = SolidityListener; // Enter a parse tree produced by SolidityParser#sourceUnit.

SolidityListener.prototype.enterSourceUnit = function (ctx) {}; // Exit a parse tree produced by SolidityParser#sourceUnit.


SolidityListener.prototype.exitSourceUnit = function (ctx) {}; // Enter a parse tree produced by SolidityParser#pragmaDirective.


SolidityListener.prototype.enterPragmaDirective = function (ctx) {}; // Exit a parse tree produced by SolidityParser#pragmaDirective.


SolidityListener.prototype.exitPragmaDirective = function (ctx) {}; // Enter a parse tree produced by SolidityParser#pragmaName.


SolidityListener.prototype.enterPragmaName = function (ctx) {}; // Exit a parse tree produced by SolidityParser#pragmaName.


SolidityListener.prototype.exitPragmaName = function (ctx) {}; // Enter a parse tree produced by SolidityParser#pragmaValue.


SolidityListener.prototype.enterPragmaValue = function (ctx) {}; // Exit a parse tree produced by SolidityParser#pragmaValue.


SolidityListener.prototype.exitPragmaValue = function (ctx) {}; // Enter a parse tree produced by SolidityParser#version.


SolidityListener.prototype.enterVersion = function (ctx) {}; // Exit a parse tree produced by SolidityParser#version.


SolidityListener.prototype.exitVersion = function (ctx) {}; // Enter a parse tree produced by SolidityParser#versionOperator.


SolidityListener.prototype.enterVersionOperator = function (ctx) {}; // Exit a parse tree produced by SolidityParser#versionOperator.


SolidityListener.prototype.exitVersionOperator = function (ctx) {}; // Enter a parse tree produced by SolidityParser#versionConstraint.


SolidityListener.prototype.enterVersionConstraint = function (ctx) {}; // Exit a parse tree produced by SolidityParser#versionConstraint.


SolidityListener.prototype.exitVersionConstraint = function (ctx) {}; // Enter a parse tree produced by SolidityParser#importDeclaration.


SolidityListener.prototype.enterImportDeclaration = function (ctx) {}; // Exit a parse tree produced by SolidityParser#importDeclaration.


SolidityListener.prototype.exitImportDeclaration = function (ctx) {}; // Enter a parse tree produced by SolidityParser#importDirective.


SolidityListener.prototype.enterImportDirective = function (ctx) {}; // Exit a parse tree produced by SolidityParser#importDirective.


SolidityListener.prototype.exitImportDirective = function (ctx) {}; // Enter a parse tree produced by SolidityParser#contractDefinition.


SolidityListener.prototype.enterContractDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#contractDefinition.


SolidityListener.prototype.exitContractDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#inheritanceSpecifier.


SolidityListener.prototype.enterInheritanceSpecifier = function (ctx) {}; // Exit a parse tree produced by SolidityParser#inheritanceSpecifier.


SolidityListener.prototype.exitInheritanceSpecifier = function (ctx) {}; // Enter a parse tree produced by SolidityParser#contractPart.


SolidityListener.prototype.enterContractPart = function (ctx) {}; // Exit a parse tree produced by SolidityParser#contractPart.


SolidityListener.prototype.exitContractPart = function (ctx) {}; // Enter a parse tree produced by SolidityParser#stateVariableDeclaration.


SolidityListener.prototype.enterStateVariableDeclaration = function (ctx) {}; // Exit a parse tree produced by SolidityParser#stateVariableDeclaration.


SolidityListener.prototype.exitStateVariableDeclaration = function (ctx) {}; // Enter a parse tree produced by SolidityParser#usingForDeclaration.


SolidityListener.prototype.enterUsingForDeclaration = function (ctx) {}; // Exit a parse tree produced by SolidityParser#usingForDeclaration.


SolidityListener.prototype.exitUsingForDeclaration = function (ctx) {}; // Enter a parse tree produced by SolidityParser#structDefinition.


SolidityListener.prototype.enterStructDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#structDefinition.


SolidityListener.prototype.exitStructDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#constructorDefinition.


SolidityListener.prototype.enterConstructorDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#constructorDefinition.


SolidityListener.prototype.exitConstructorDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#modifierDefinition.


SolidityListener.prototype.enterModifierDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#modifierDefinition.


SolidityListener.prototype.exitModifierDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#modifierInvocation.


SolidityListener.prototype.enterModifierInvocation = function (ctx) {}; // Exit a parse tree produced by SolidityParser#modifierInvocation.


SolidityListener.prototype.exitModifierInvocation = function (ctx) {}; // Enter a parse tree produced by SolidityParser#functionDefinition.


SolidityListener.prototype.enterFunctionDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#functionDefinition.


SolidityListener.prototype.exitFunctionDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#returnParameters.


SolidityListener.prototype.enterReturnParameters = function (ctx) {}; // Exit a parse tree produced by SolidityParser#returnParameters.


SolidityListener.prototype.exitReturnParameters = function (ctx) {}; // Enter a parse tree produced by SolidityParser#modifierList.


SolidityListener.prototype.enterModifierList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#modifierList.


SolidityListener.prototype.exitModifierList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#eventDefinition.


SolidityListener.prototype.enterEventDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#eventDefinition.


SolidityListener.prototype.exitEventDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#enumValue.


SolidityListener.prototype.enterEnumValue = function (ctx) {}; // Exit a parse tree produced by SolidityParser#enumValue.


SolidityListener.prototype.exitEnumValue = function (ctx) {}; // Enter a parse tree produced by SolidityParser#enumDefinition.


SolidityListener.prototype.enterEnumDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#enumDefinition.


SolidityListener.prototype.exitEnumDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#parameterList.


SolidityListener.prototype.enterParameterList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#parameterList.


SolidityListener.prototype.exitParameterList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#parameter.


SolidityListener.prototype.enterParameter = function (ctx) {}; // Exit a parse tree produced by SolidityParser#parameter.


SolidityListener.prototype.exitParameter = function (ctx) {}; // Enter a parse tree produced by SolidityParser#eventParameterList.


SolidityListener.prototype.enterEventParameterList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#eventParameterList.


SolidityListener.prototype.exitEventParameterList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#eventParameter.


SolidityListener.prototype.enterEventParameter = function (ctx) {}; // Exit a parse tree produced by SolidityParser#eventParameter.


SolidityListener.prototype.exitEventParameter = function (ctx) {}; // Enter a parse tree produced by SolidityParser#functionTypeParameterList.


SolidityListener.prototype.enterFunctionTypeParameterList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#functionTypeParameterList.


SolidityListener.prototype.exitFunctionTypeParameterList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#functionTypeParameter.


SolidityListener.prototype.enterFunctionTypeParameter = function (ctx) {}; // Exit a parse tree produced by SolidityParser#functionTypeParameter.


SolidityListener.prototype.exitFunctionTypeParameter = function (ctx) {}; // Enter a parse tree produced by SolidityParser#variableDeclaration.


SolidityListener.prototype.enterVariableDeclaration = function (ctx) {}; // Exit a parse tree produced by SolidityParser#variableDeclaration.


SolidityListener.prototype.exitVariableDeclaration = function (ctx) {}; // Enter a parse tree produced by SolidityParser#typeName.


SolidityListener.prototype.enterTypeName = function (ctx) {}; // Exit a parse tree produced by SolidityParser#typeName.


SolidityListener.prototype.exitTypeName = function (ctx) {}; // Enter a parse tree produced by SolidityParser#userDefinedTypeName.


SolidityListener.prototype.enterUserDefinedTypeName = function (ctx) {}; // Exit a parse tree produced by SolidityParser#userDefinedTypeName.


SolidityListener.prototype.exitUserDefinedTypeName = function (ctx) {}; // Enter a parse tree produced by SolidityParser#mapping.


SolidityListener.prototype.enterMapping = function (ctx) {}; // Exit a parse tree produced by SolidityParser#mapping.


SolidityListener.prototype.exitMapping = function (ctx) {}; // Enter a parse tree produced by SolidityParser#functionTypeName.


SolidityListener.prototype.enterFunctionTypeName = function (ctx) {}; // Exit a parse tree produced by SolidityParser#functionTypeName.


SolidityListener.prototype.exitFunctionTypeName = function (ctx) {}; // Enter a parse tree produced by SolidityParser#storageLocation.


SolidityListener.prototype.enterStorageLocation = function (ctx) {}; // Exit a parse tree produced by SolidityParser#storageLocation.


SolidityListener.prototype.exitStorageLocation = function (ctx) {}; // Enter a parse tree produced by SolidityParser#stateMutability.


SolidityListener.prototype.enterStateMutability = function (ctx) {}; // Exit a parse tree produced by SolidityParser#stateMutability.


SolidityListener.prototype.exitStateMutability = function (ctx) {}; // Enter a parse tree produced by SolidityParser#block.


SolidityListener.prototype.enterBlock = function (ctx) {}; // Exit a parse tree produced by SolidityParser#block.


SolidityListener.prototype.exitBlock = function (ctx) {}; // Enter a parse tree produced by SolidityParser#statement.


SolidityListener.prototype.enterStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#statement.


SolidityListener.prototype.exitStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#expressionStatement.


SolidityListener.prototype.enterExpressionStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#expressionStatement.


SolidityListener.prototype.exitExpressionStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#ifStatement.


SolidityListener.prototype.enterIfStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#ifStatement.


SolidityListener.prototype.exitIfStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#whileStatement.


SolidityListener.prototype.enterWhileStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#whileStatement.


SolidityListener.prototype.exitWhileStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#simpleStatement.


SolidityListener.prototype.enterSimpleStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#simpleStatement.


SolidityListener.prototype.exitSimpleStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#forStatement.


SolidityListener.prototype.enterForStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#forStatement.


SolidityListener.prototype.exitForStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#inlineAssemblyStatement.


SolidityListener.prototype.enterInlineAssemblyStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#inlineAssemblyStatement.


SolidityListener.prototype.exitInlineAssemblyStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#doWhileStatement.


SolidityListener.prototype.enterDoWhileStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#doWhileStatement.


SolidityListener.prototype.exitDoWhileStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#continueStatement.


SolidityListener.prototype.enterContinueStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#continueStatement.


SolidityListener.prototype.exitContinueStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#breakStatement.


SolidityListener.prototype.enterBreakStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#breakStatement.


SolidityListener.prototype.exitBreakStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#returnStatement.


SolidityListener.prototype.enterReturnStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#returnStatement.


SolidityListener.prototype.exitReturnStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#throwStatement.


SolidityListener.prototype.enterThrowStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#throwStatement.


SolidityListener.prototype.exitThrowStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#emitStatement.


SolidityListener.prototype.enterEmitStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#emitStatement.


SolidityListener.prototype.exitEmitStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#variableDeclarationStatement.


SolidityListener.prototype.enterVariableDeclarationStatement = function (ctx) {}; // Exit a parse tree produced by SolidityParser#variableDeclarationStatement.


SolidityListener.prototype.exitVariableDeclarationStatement = function (ctx) {}; // Enter a parse tree produced by SolidityParser#variableDeclarationList.


SolidityListener.prototype.enterVariableDeclarationList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#variableDeclarationList.


SolidityListener.prototype.exitVariableDeclarationList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#identifierList.


SolidityListener.prototype.enterIdentifierList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#identifierList.


SolidityListener.prototype.exitIdentifierList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#elementaryTypeName.


SolidityListener.prototype.enterElementaryTypeName = function (ctx) {}; // Exit a parse tree produced by SolidityParser#elementaryTypeName.


SolidityListener.prototype.exitElementaryTypeName = function (ctx) {}; // Enter a parse tree produced by SolidityParser#expression.


SolidityListener.prototype.enterExpression = function (ctx) {}; // Exit a parse tree produced by SolidityParser#expression.


SolidityListener.prototype.exitExpression = function (ctx) {}; // Enter a parse tree produced by SolidityParser#primaryExpression.


SolidityListener.prototype.enterPrimaryExpression = function (ctx) {}; // Exit a parse tree produced by SolidityParser#primaryExpression.


SolidityListener.prototype.exitPrimaryExpression = function (ctx) {}; // Enter a parse tree produced by SolidityParser#expressionList.


SolidityListener.prototype.enterExpressionList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#expressionList.


SolidityListener.prototype.exitExpressionList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#nameValueList.


SolidityListener.prototype.enterNameValueList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#nameValueList.


SolidityListener.prototype.exitNameValueList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#nameValue.


SolidityListener.prototype.enterNameValue = function (ctx) {}; // Exit a parse tree produced by SolidityParser#nameValue.


SolidityListener.prototype.exitNameValue = function (ctx) {}; // Enter a parse tree produced by SolidityParser#functionCallArguments.


SolidityListener.prototype.enterFunctionCallArguments = function (ctx) {}; // Exit a parse tree produced by SolidityParser#functionCallArguments.


SolidityListener.prototype.exitFunctionCallArguments = function (ctx) {}; // Enter a parse tree produced by SolidityParser#functionCall.


SolidityListener.prototype.enterFunctionCall = function (ctx) {}; // Exit a parse tree produced by SolidityParser#functionCall.


SolidityListener.prototype.exitFunctionCall = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyBlock.


SolidityListener.prototype.enterAssemblyBlock = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyBlock.


SolidityListener.prototype.exitAssemblyBlock = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyItem.


SolidityListener.prototype.enterAssemblyItem = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyItem.


SolidityListener.prototype.exitAssemblyItem = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyExpression.


SolidityListener.prototype.enterAssemblyExpression = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyExpression.


SolidityListener.prototype.exitAssemblyExpression = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyCall.


SolidityListener.prototype.enterAssemblyCall = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyCall.


SolidityListener.prototype.exitAssemblyCall = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyLocalDefinition.


SolidityListener.prototype.enterAssemblyLocalDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyLocalDefinition.


SolidityListener.prototype.exitAssemblyLocalDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyAssignment.


SolidityListener.prototype.enterAssemblyAssignment = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyAssignment.


SolidityListener.prototype.exitAssemblyAssignment = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyIdentifierOrList.


SolidityListener.prototype.enterAssemblyIdentifierOrList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyIdentifierOrList.


SolidityListener.prototype.exitAssemblyIdentifierOrList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyIdentifierList.


SolidityListener.prototype.enterAssemblyIdentifierList = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyIdentifierList.


SolidityListener.prototype.exitAssemblyIdentifierList = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyStackAssignment.


SolidityListener.prototype.enterAssemblyStackAssignment = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyStackAssignment.


SolidityListener.prototype.exitAssemblyStackAssignment = function (ctx) {}; // Enter a parse tree produced by SolidityParser#labelDefinition.


SolidityListener.prototype.enterLabelDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#labelDefinition.


SolidityListener.prototype.exitLabelDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblySwitch.


SolidityListener.prototype.enterAssemblySwitch = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblySwitch.


SolidityListener.prototype.exitAssemblySwitch = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyCase.


SolidityListener.prototype.enterAssemblyCase = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyCase.


SolidityListener.prototype.exitAssemblyCase = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyFunctionDefinition.


SolidityListener.prototype.enterAssemblyFunctionDefinition = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyFunctionDefinition.


SolidityListener.prototype.exitAssemblyFunctionDefinition = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyFunctionReturns.


SolidityListener.prototype.enterAssemblyFunctionReturns = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyFunctionReturns.


SolidityListener.prototype.exitAssemblyFunctionReturns = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyFor.


SolidityListener.prototype.enterAssemblyFor = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyFor.


SolidityListener.prototype.exitAssemblyFor = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyIf.


SolidityListener.prototype.enterAssemblyIf = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyIf.


SolidityListener.prototype.exitAssemblyIf = function (ctx) {}; // Enter a parse tree produced by SolidityParser#assemblyLiteral.


SolidityListener.prototype.enterAssemblyLiteral = function (ctx) {}; // Exit a parse tree produced by SolidityParser#assemblyLiteral.


SolidityListener.prototype.exitAssemblyLiteral = function (ctx) {}; // Enter a parse tree produced by SolidityParser#subAssembly.


SolidityListener.prototype.enterSubAssembly = function (ctx) {}; // Exit a parse tree produced by SolidityParser#subAssembly.


SolidityListener.prototype.exitSubAssembly = function (ctx) {}; // Enter a parse tree produced by SolidityParser#tupleExpression.


SolidityListener.prototype.enterTupleExpression = function (ctx) {}; // Exit a parse tree produced by SolidityParser#tupleExpression.


SolidityListener.prototype.exitTupleExpression = function (ctx) {}; // Enter a parse tree produced by SolidityParser#elementaryTypeNameExpression.


SolidityListener.prototype.enterElementaryTypeNameExpression = function (ctx) {}; // Exit a parse tree produced by SolidityParser#elementaryTypeNameExpression.


SolidityListener.prototype.exitElementaryTypeNameExpression = function (ctx) {}; // Enter a parse tree produced by SolidityParser#numberLiteral.


SolidityListener.prototype.enterNumberLiteral = function (ctx) {}; // Exit a parse tree produced by SolidityParser#numberLiteral.


SolidityListener.prototype.exitNumberLiteral = function (ctx) {}; // Enter a parse tree produced by SolidityParser#identifier.


SolidityListener.prototype.enterIdentifier = function (ctx) {}; // Exit a parse tree produced by SolidityParser#identifier.


SolidityListener.prototype.exitIdentifier = function (ctx) {};

exports.SolidityListener = SolidityListener;